import { useFeatureFlag } from '../hooks/useFeatureFlag'
import { UpgradeBanner } from '../components/ui/UpgradeBanner'
import { ChatSupportDashboard } from '../components/chat/ChatSupportDashboard'

export default function ChatDashboardPage() {
  const { enabled, loading, requiredPlan } = useFeatureFlag('tickets')

  if (loading) return <div style={{ padding: 24 }}>Loading...</div>
  if (!enabled) return <UpgradeBanner feature="Live Chat" plan={requiredPlan} />

  return (
    <div className="page-enter" style={{ padding: 0 }}>
      <div style={{ padding: '16px 24px 0' }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 16 }}>
          Live Chat
        </h1>
      </div>
      <div style={{ padding: '0 24px 24px' }}>
        <ChatSupportDashboard />
      </div>
    </div>
  )
}
